import React from "react";

import type { GroupListItem, GroupListFieldType } from "../../GroupList/GroupList";

import SearchFilterButton from "./SearchFilterButton";
import SearchFilterMenu from "./SearchFilterMenu";

interface SearchFilterProps {
    disabled?: boolean;
    fieldType: GroupListFieldType;
    items: GroupListItem[];
    label: string;
    onClear?: () => void;
    onChange?: (listItem: GroupListItem) => void;
    onSave?: () => void;
}

/**
 * Search Filter
 */
const SearchFilter = (props: SearchFilterProps) => {
    const {
        disabled = false,
        fieldType,
        items,
        label,
        onClear,
        onChange,
        onSave
    } = props;

    const [menuOpen, setMenuOpen] = React.useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    React.useEffect(() => {
        setMenuOpen(false);
    }, [disabled]);

    const createSelectionArray = (itemsArray: GroupListItem[]): GroupListItem[] => {
        let itemsForSearchFilter = itemsArray;
        let selections = [];
        const isNested = itemsArray[0] && "items" in itemsArray[0] && itemsArray[0]?.items?.length;
        if (isNested) {
            itemsForSearchFilter = items;
            selections = itemsForSearchFilter.map((group: GroupListItem) =>
                "items" in group ? group?.items?.filter((item: GroupListItem) => (item.defaultChecked ? item.label : null)) : []
            ).flat();
        } else {
            itemsForSearchFilter = items as GroupListItem[];
            selections = itemsForSearchFilter.filter(
                (item: GroupListItem) => (item.defaultChecked ? item.label : null)
            );
        }
        return selections as GroupListItem[];
    };

    const selectionString = (itemsArray: GroupListItem[]) => {
        const selections = createSelectionArray(itemsArray);
        if (!selections || selections.length < 1) {
            return "";
        }
        if (selections.length === 1) {
            return selections[0].label;
        }
        return `${selections.length} Selected`;
    };

    return (
        <>
            {menuOpen === false && (
                <SearchFilterButton
                    label={label}
                    selections={selectionString(items)}
                    onClick={toggleMenu}
                    disabled={disabled}
                />
            )}
            {menuOpen && !disabled && (
                <SearchFilterMenu
                    title={label}
                    items={items}
                    fieldType={fieldType}
                    onCheckboxChange={onChange}
                    onClose={toggleMenu}
                    onClear={onClear}
                    onSave={onSave}
                />
            )}
        </>
    );
};

export { SearchFilter as default };
export type { SearchFilterProps };
